// Web stub for Luciq SDK (native mobile only)

module.exports = {
  logOut: () => {},
  identifyUser: () => {},
};
